import * as React from "react";

export type NamedRoute<T> = {
  link: (t: T) => string;
  forRouter: {
    path: string;
    component: React.ComponentType<any>;
    hidden?: boolean;
  };
};

export function route<T>(args: {
  link?: (t: T) => string;
  path: string;
  component: React.ComponentType<any>;
  hidden?: boolean;
}): NamedRoute<T> {
  return {
    link: args.link ? args.link : () => args.path,
    forRouter: {
      path: args.path,
      component: args.component,
      hidden: args.hidden,
    },
  };
}
